import "~/misc/common";
import { p } from "~/misc/common";
import Cookies from "js-cookie";
import { Calendar, EventSourceApi } from '@fullcalendar/core';
import { CalendarOpts } from "./calendar";

export function initCalTrainings(cal: Calendar, opts: CalendarOpts) {
  p('initCalTrainings');

  const calendar = cal;
  Cookies.set('training_back', window.location.href, { path: '/' });
  Cookies.set('training_form_back', window.location.href, { path: '/' });

  let source: EventSourceApi | null = null;
  let active = !(Cookies.get('cal_no_trainings') == 'true');

  // create button dynamically
  const btn = $('<button>', {
    class: 'btn btn-default margin-left-5px margin-bottom-5px toggle-calendar-trainings',
    html: '<i class="fa fa-graduation-cap"></i> Továbbképzések'
  });
  $('#btnContainer').append(btn);
  btn.on('click', function (e) {
    $(this).blur();
    active = !active;
    refresh();
  });

  // create button dynamically
  const btnNew = $('<button>', {
    class: 'btn btn-default margin-5px new-calendar-training',
    html: '<i class="fa fa-graduation-cap"></i> Új továbbképzés'
  });
  if (opts.trainings_create) $('#btnNewContainer').append(btnNew);
  btnNew.on('click', function () {
    const newQuery = $("#modalNewEntry").data("new-query");
    window.location.replace("/trainings/new?" + newQuery);
  });

  refresh();

  function refresh() {
    active ? btn.addClass('active') : btn.removeClass('active');
    active ? $(btnNew).show() : $(btnNew).hide();
    Cookies.set('cal_no_trainings', (!active) + '', {
      expires: 10,
      path: '/'
    });
    if (source) {
      active ? calendar.addEventSource(source) : source.remove();
    } else if (active) {
      source = calendar.addEventSource({
        url: '/trainings.json',
        extraParams: {
          'q[user_id_eq]': opts.user_id
        }
      });
    }
  }
}